export { Footer } from './Footer';
export { FooterTeaser } from './Footer.styles';
export { BrandText as FooterBrandText } from './BrandText';
